import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('BugReport')
export class BugReport {

  @JsonProperty('bug_report_id', Number)
  bugReportId: number = 0;

  @JsonProperty('user_id', Number)
  userId: number = 0;

  @JsonProperty('user_displayname', String)
  userDisplayname: string = '';

  @JsonProperty('user_locale', String)
  userLocale: string = '';

  @JsonProperty('description', String)
  description: string = '';

  @JsonProperty('mail', String)
  mail: string = '';

  @JsonProperty('bug_type', Number)
  bugType: number = 0;

  @JsonProperty('rate', Number)
  rate: number = 0;

  @JsonProperty('application_version', Any)
  applicationVersion: string | null = null;

  @JsonProperty('created_at_timestamp', Number)
  createdAtTimestamp: number = 0;

  @JsonProperty('is_closed', Boolean)
  isClosed: boolean = false;

  @JsonProperty('shop_buy_credits', Any)
  shopBuyCredits: number | null = null;

  @JsonProperty('last_match_id', Any)
  lastMatchId: number | null = null;
}
